export default __webpack_public_path__ + "static/media/nodejs.5a3a9ca2.svg";